export default __webpack_public_path__ + "/dist/images/logo-sm.1dc7ee428f79b1217488670134a3ec96.png";